import LoginForm from "../Common/LoginForm";
import { Col } from "reactstrap";
import { dynamicImage } from "../../../Service/DynamicImage";
import RatioImage from "../../../CommonElements/RatioImage";

const LoginWithValidationContainer = () => {
  return (
    <>
      <Col xl="7" className="order-1 p-0">
        <RatioImage className="bg-img-cover bg-center img-fluid w-100" src={dynamicImage("login/1.jpg")} alt="looginpage" />
      </Col>
      <Col xl="5" className="p-0">
        <div className="login-card login-dark">
          <LoginForm validation logoClass="text-start" />
        </div>
      </Col>
    </>
  );
};

export default LoginWithValidationContainer;
